
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 8.182V3.477C0 1.57 1.423 0 3.202 0c1.716 0 3.1 1.459 3.197 3.273h.806a.81.81 0 01.801.818.81.81 0 01-.8.818H4.804a.81.81 0 01-.801-.818.81.81 0 01.79-.818c-.088-.925-.77-1.637-1.59-1.637-.88 0-1.602.82-1.602 1.841v3.887h17.613v.803c0 2.648-1.49 4.962-3.618 5.992a.84.84 0 01.016.16v2.454a.81.81 0 01-.801.818.81.81 0 01-.8-.818v-2.115c-.287.046-.58.07-.878.07H6.081a5.65 5.65 0 01-.877-.069v2.114a.81.81 0 01-.8.818.81.81 0 01-.801-.818v-2.455a.84.84 0 01.014-.153C1.49 13.145.005 10.845 0 8.182zm6.081 4.938h7.052c2.213 0 4.088-1.788 4.45-4.15H1.637c.373 2.374 2.236 4.15 4.444 4.15z","fill":"#fff","fill-rule":"nonzero"}})])
          )
        }
      }
    